import Hero from "../../Components/Hero/hero"
function Home() {
    return (
        <>
            <main>
                <Hero />
            </main>
        </>
    )
}

export default Home